import Register           from '@/components/#pages/validate/Validate' //Register

export default [
    {
        path:'/validate',
        name:'validate',
        component: Register,
        meta: {
            protectedLogin: false //Proteger ruta en caso de que este autentificado.
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/redsocial.js